import { countryRestrictions } from '@authorizedInstaller/constants';
import { AuthorizedInstallersContext } from '@authorizedInstaller/contexts/AuthorizedInstallersContext';
import { Filters } from '@common/types/service';
import { Select } from '@components/utility/selects';
import { FormControl, TextField } from '@mui/material';
import { useGetDistributorsQuery, useGetSalesManagersQuery } from '@services/accounts';
import { useContext } from 'react';

const GeneralStep = () => {
    const countryFilters: Filters = {
        country_id: countryRestrictions,
    };
    const { data: salesManagers, isLoading: isSalesManagerDataLoading } = useGetSalesManagersQuery(countryFilters, {
        selectFromResult: (response) => ({
            ...response,
            data: response.data?.map((user) => ({ label: user.full_name, value: user.id })) ?? [],
        }),
    });
    const { data: distributors, isLoading: isDistributorDataLoading } = useGetDistributorsQuery(countryFilters);
    const {
        formik: { values, touched, errors, handleChange, handleBlur },
    } = useContext(AuthorizedInstallersContext);

    return (
        <div className="flex flex-col gap-4">
            <div className="flex flex-col w-full gap-4 md:flex-row">
                <FormControl fullWidth>
                    <TextField
                        name="first_name"
                        label="First Name"
                        value={values.first_name}
                        error={touched.first_name && Boolean(errors.first_name)}
                        helperText={touched.first_name && errors.first_name ? errors.first_name : ''}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        slotProps={{
                            inputLabel: {
                                required: true,
                            },
                        }}
                    />
                </FormControl>
                <FormControl fullWidth>
                    <TextField
                        name="last_name"
                        label="Last Name"
                        value={values.last_name}
                        error={touched.last_name && Boolean(errors.last_name)}
                        helperText={touched.last_name && errors.last_name ? errors.last_name : ''}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        slotProps={{
                            inputLabel: {
                                required: true,
                            },
                        }}
                    />
                </FormControl>
            </div>
            <FormControl>
                <TextField
                    name="company_name"
                    label="Company Name"
                    value={values.company_name}
                    error={touched.company_name && Boolean(errors.company_name)}
                    helperText={touched.company_name && errors.company_name ? errors.company_name : ''}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    slotProps={{
                        inputLabel: {
                            required: true,
                        },
                    }}
                />
            </FormControl>
            <FormControl>
                <Select
                    required
                    virtualize
                    searchable
                    autoClose
                    multiple={false}
                    type="default"
                    disabled={isDistributorDataLoading}
                    name="distributor"
                    label="Distributor"
                    fcSX={{
                        required: true,
                    }}
                    items={
                        distributors?.map((distributor) => ({
                            label: distributor.company_name,
                            value: distributor.id,
                        })) ?? []
                    }
                    value={values.distributor}
                    error={touched.distributor && Boolean(errors.distributor)}
                    helperText={touched.distributor && errors.distributor ? errors.distributor : ''}
                    onChange={handleChange}
                    onBlur={handleBlur}
                ></Select>
            </FormControl>
            <FormControl>
                <Select
                    required
                    virtualize
                    searchable
                    autoClose
                    multiple={false}
                    type="default"
                    disabled={isSalesManagerDataLoading}
                    name="sales_manager"
                    label="Sales Manager"
                    fcSX={{
                        required: true,
                    }}
                    items={salesManagers}
                    value={values.sales_manager}
                    error={touched.sales_manager && Boolean(errors.sales_manager)}
                    helperText={touched.sales_manager && errors.sales_manager ? errors.sales_manager : ''}
                    onChange={handleChange}
                    onBlur={handleBlur}
                ></Select>
            </FormControl>
        </div>
    );
};

export { GeneralStep };
